import React from 'react'

const AuditCreate = () => {
  return <>{''}</>
}

export default AuditCreate
